import React from 'react'

import {ReactComponent as Minus} from '../../../../images/main/minus_usefulInfo.svg'
import {ReactComponent as Plus} from '../../../../images/main/plus_usefulInfo.svg'

import styles from './styles.module.scss'
import {Link} from 'react-router-dom'

const QuestionInterShips = () => {
  const [activeField, setActiveField] = React.useState(0)
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <div>
          <p className={styles.title}>
            И ещё немного о программе
          </p>
        </div>
      </div>
      <div className={styles.right}>
        <p className={styles.title}>Вопросы и ответы</p>
        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(1))}
              className={
                activeField === 2 || activeField === 3 || activeField === 4 || activeField === 5 || activeField === 6
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Стажировка оплачивается?
            </p>
            {activeField === 1 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(1)}/>
            )}
          </div>
          {activeField === 1 && (
            <>
              <p className={styles.answer}>
                Да. Мы официально трудоустраиваем стажеров и платим 40 тысяч рублей в месяц до вычета налогов.
              </p>
            </>
          )}
        </div>
        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(2))}
              className={
                activeField === 1 || activeField === 3 || activeField === 4 || activeField === 5 || activeField === 6
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Могу ли я выбрать направление стажировки?
            </p>
            {activeField === 2 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(2)}/>
            )}
          </div>
          {activeField === 2 && (
            <p className={styles.answer}>
              Да. При распределении мы отталкиваемся от твоих пожеланий.
            </p>
          )}
        </div>
        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(3))}
              className={
                activeField === 2 || activeField === 1 || activeField === 4 || activeField === 5 || activeField === 6
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Могу ли я пройти стажировку повторно?
            </p>
            {activeField === 3 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(3)}/>
            )}
          </div>
          {activeField === 3 &&
            <p className={styles.answer}>Да. Мы всегда рады видеть знакомые лица на стажировке.</p>}
        </div>

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(4))}
              className={
                activeField === 2 || activeField === 3 || activeField === 1 || activeField === 5 || activeField === 6
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Где будет проходить стажировка?
            </p>
            {activeField === 4 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(4)}/>
            )}
          </div>
          {activeField === 4 && (
            <>
              <p className={styles.answer}>
                Стажировки проходят в п.&nbsp;Вольгинском, на площадке Алабушево (г. Зеленоград) и в Москве. Место стажировки зависит от направления. Подробнее о жизни в Вольгинском ты можешь прочитать в разделе «Релокация».
              </p>
              <Link to='/relocation'>
                <button className={styles.title_btn}>
                  Релокация <span>&rarr;</span>
                </button>
              </Link>
            </>
          )}
        </div>

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(5))}
              className={
                activeField === 2 || activeField === 3 || activeField === 1 || activeField === 4 || activeField === 6
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Могу ли я пройти производственную практику от университета?
            </p>
            {activeField === 5 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(5)}/>
            )}
          </div>
          {activeField === 5 && (
            <>
              <p className={styles.answer}>
                Да. Практику можно совместить со стажировкой.
              </p>
            </>
          )}
        </div>

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(6))}
              className={
                activeField === 2 || activeField === 3 || activeField === 1 || activeField === 4 || activeField === 5
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Можно ли совмещать стажировку с учебой?
            </p>
            {activeField === 6 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(6)}/>
            )}
          </div>
          {activeField === 6 && (
            <>
              <p className={styles.answer}>
                Стажировка длится от 1 до 6 месяцев и предполагает полноценную работу, после которой ты сможешь получить штатную должность в компании, поэтому совмещать не получится.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default QuestionInterShips
